import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	smsProviderCheck: false, // SMS provider added
	salesChannelCheck: false, // Sales channel added
	branchCheck: false, // Branch added
	warehouseCheck: false, // Warehouse added
	boxDimensionCheck: false, // Box dimension added
	isQualifiedUser: false,
	walletCheck: false, // Charged account
	otoFlexCheck: false, // OTO Flex activated
	shipmentCheck: false, // Shipment created
	printSettingsCheck: false, // Print settings configured
	printAWBCheck: false, // Printed AWB
	dcConnectionCheck: false, // DC Integration added at least one
	isOnboarded: false,
	orderCheck: false, // Order added manually
	qualificationJSON: {
		onboardingChecklist: ['PhoneNumber', 'PickupLocation', 'SalesChannel', 'ChargeAccount', 'AddOrders']
	},
	calculatePriceCheck: false, // Aggregator prices seen
	codShipmentCheck: false, // COD shipment created for aggregator order
	bankInfoCheck: false, // Bank info added to check
	monetizedIntroVideo: false, // Monetized intro video
	WMSModuleCheck: false, // WMS module added
	WMSAdvanceModuleCheck: false, // WMS advance module added
	userCheck: false, // User added
	productCheck: false, // Product added,
	inventoryCheck: false, // Inventory added
	secondShipmentCheck: false,
	cohortAggCheck: false,
	skipSalesChannelCheck: false
};

const instruction = createSlice({
	name: 'instruction',
	initialState,
	reducers: {
		setInstructionData: (state, { payload }) => ({
			...state,
			...payload,
			...(payload.qualificationJSON ? { qualificationJSON: JSON.parse(payload.qualificationJSON) } : {})
		}),
		updateInstructionData: (state, { payload }) => ({
			...state,
			...payload
		})
	}
});

export const { setInstructionData, updateInstructionData } = instruction.actions;

export default instruction.reducer;
